import dynamic from "next/dynamic";
import React, { useState, useEffect, useRef } from "react";
import imageUrlBuilder from "@sanity/image-url";
import Image from "next/image";
const PostCard = dynamic(() => import("../../components/PostCard"));
const Grid = dynamic(() => import("@mui/material/Grid"));

import { client } from "../../../lib/client";
import { motion } from "framer-motion";
import UseAnimationIos from "../api/UseAnimationIos";
import { imageScale } from "@/utils/motion";

import Head from "next/head";
import styles from "@/styles/blogs.module.css";
const PostCard2 = dynamic(() => import("../../components/PostCard2"));

const SeoComponents = () => (
  <Head>
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://techcelerant.com/casestudy" />
    <title>Transforming Brands: A Case Study on Strategic Development and Growth</title>
    <meta
      name="description"
      content="Discover how TechCelerant transformed a struggling brand into a market leader through strategic development and growth. Explore our comprehensive case study for insights and actionable strategies."
    />
    <link rel="apple-touch-icon" href="apple-touch-icon.png" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="icon" href="/favicon.ico" />
    <link rel="preconnect" href="https://fonts.googleapis.com"/>
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
<link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"/>
  
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"/>
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Karla:ital,wght@0,200..800;1,200..800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"/>
  </Head>
);

const CaseStudy = ({ posts }) => {
  const divStyle = {
    backgroundImage: `url(${'/Bannerru.jpg'})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const [selectedCategory, setSelectedCategory] = useState('All');
  const [displayedPostsCount, setDisplayedPostsCount] = useState(5);
  const [mappedPosts, setMappedPosts] = useState([]);

  const categories = [
    'All',
    'Web Development',
    'Graphic Designing',
    'Mobile App Development',
    'Social Media Management',
    'Digital Marketing'
  ];

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setDisplayedPostsCount(5); // Reset the displayed posts count when the category changes
  };

  const handleLoadMore = () => {
    setDisplayedPostsCount((prevCount) => prevCount + posts.length - prevCount); // Load all remaining posts
  };

  useEffect(() => {
    const imageBuilder = imageUrlBuilder(client);
    const formattedPosts = posts.map((post) => ({
      ...post,
      mainImage: imageBuilder?.image(post?.mainImage).url(),
      author_Image: imageBuilder
        ?.image(post?.author.image)
        .width(1000)
        .height(1000)
        .url(),
    }));

    if (selectedCategory === 'All') {
      setMappedPosts(formattedPosts.slice(0, displayedPostsCount));
    } else {
      const filteredPosts = formattedPosts.filter(post =>
        post.categories?.some(cat => cat === selectedCategory)
      );
      setMappedPosts(filteredPosts.slice(0, displayedPostsCount));
    }
  }, [posts, selectedCategory, displayedPostsCount]);

  const [onScreen, setOnScreen] = useState(false);
  const ref = useRef();
  UseAnimationIos(ref, setOnScreen);
  const animation = onScreen ? imageScale(1.5).animate : imageScale(0.5).initial;

  return (
    <>
      <SeoComponents />

      <div style={divStyle} className={`${styles["blogs-main-container"]} min-h-[40vh] pb-[6rem] sm:pb-[1rem]`}>
        <div className="min-w-[50%] flex flex-col justify-center items-center">
          <h1 className="text-center sm:text-start text-white text-[2rem] sm:text-[4rem] uppercase">
            Case Study
          </h1>
        </div>
      </div>

      <div className="bg-white" ref={ref}>
        <div className="pt-20">
          <p className="text-center font-semibold text-[40px] text-[#513875]">
          Highlighted Achievements from Our Extensive <br />Project
          </p>
        </div>

        <div className="flex justify-center pb-16">
          <div className="w-full sm:max-w-[100%] xl:max-w-[60%] pt-6 px-4">
            <p className="text-[18px] font-bold">Filter Case Studies:</p>
            <div className="flex flex-wrap justify-center gap-3 mt-3">
              {categories.map((category) => (
                <p
                  key={category}
                  className={`px-6 py-2 rounded-full font-medium text-[16px] cursor-pointer transition duration-300 whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-black text-white'
                      : 'bg-[#F7F7F7] text-black'
                  }`}
                  onClick={() => handleCategoryClick(category)}
                >
                  {category}
                </p>
              ))}
            </div>
          </div>
        </div>

        <motion.div
          initial={imageScale(0.5).initial}
          animate={animation}
          className="px-2 sm:px-0 max-w-[100%] m-auto"
        >
          {mappedPosts &&
            mappedPosts.length > 0 &&
            mappedPosts.map((post, index) => (
              <PostCard2 data={post} key={index} index={index} />
            ))}
        </motion.div>

        {mappedPosts.length < posts.length && (
          <div className="flex justify-center mt-16 pb-24">
            <button
              className="text-[15px] uppercase px-12 py-6 border-2 border-black text-[#16202F] karla-fons"
              onClick={handleLoadMore}
            >
              Load More Posts
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export const getStaticProps = async () => {
  const productsQuery = `*[_type == "casestudy"] | order(publishedAt desc) {
    ...,
    "categories": categories[]->title,
    author-> {
      _id,
      name,
      image,
      // add other fields you want from the author here
    }
  }`;

  const posts = await client.fetch(productsQuery);

  return {
    props: { posts },
    revalidate: 1, // add this line to re-fetch data at most once per second
  };
};

export default CaseStudy;
